<!-- @format -->
<ng-container *transloco="let t">
  <div class="calendar-view-container container-fluid">
    <div class="row">
      <div class="col-12 col-md-8 col-xl-9 calendar-content-area">
        <app-full-calendar (toggleRightBar)="handleToggleRightBar($event)"></app-full-calendar>
      </div>
      <div class="col-10 col-sm-6 col-md-4 col-xl-3 calendar-right-bar" [ngClass]="{ closed: !isRightPanelOpen() }">
        <div class="calendar-right-bar-header">
          <button
            #closeRightBarBtn
            type="button"
            (click)="closeRightBar()"
            class="non-button collapsible-column-dismiss"
            [attr.aria-label]="t('ARIA_LABEL.CLOSE') + ', ' + t('COURSE_UNIT_REALISATIONS')">
            <sis-icon icon="close" color="white"></sis-icon>
          </button>
          <sis-tab-navigation [type]="'wide'" [tabs]="tabs"></sis-tab-navigation>
        </div>
        <div ui-view class="calendar-right-bar-content"></div>
      </div>
    </div>
  </div>
</ng-container>
